<template>
<div id="app" :class="vueAppClasses" dir>


    <b-modal title="Opps!" hide-header-close no-close-on-esc no-close-on-backdrop id="preloadError" modal-class="custom-modal" hide-footer centered size="lg">
        <div class="d-block p-4">
            <b-row>
                <b-col>
                    <div class="block-modal-content fw-600 bg-white">
                        <div class="modal-content_text ml-3">
                            <p class="m-0">Đã có lỗi trong quá trình thiết lập đề, hãy kiểm tra kết nối mạng hoặc sử dụng thiết bị khác</p>
                            <br>
                            <code class="m-0">{{ getTrackingId() }}</code>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-modal>

    <b-modal hide-header-close no-close-on-esc no-close-on-backdrop id="uploadProcess" modal-class="custom-modal" hide-footer centered size="lg">
        <div class="d-block p-4">
            <b-row>
                <b-col>
                    <div class="block-modal-content mr-0 fw-600 bg-white">
                        <div class="modal-content_text w-100 text-center">
                            <p class="m-0 mb-4 text-center">Phần thi speaking của bạn đã hoàn thành, các nội dung đang được tải lên.<br>Hãy cùng xem lại một lần nữa nhé!</p>

                            <div>
                                <div class="mb-4 shadow px-3 " v-for="(item, index) in uploadProcess" :key="index">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center">
                                            <p class="fw-light mb-0 mr-2">
                                                {{ jsonParse(item?.question?.content).title }} - 
                                                <span v-if="!item.error && item.loaded" class="text-success">XONG</span>
                                                <span v-if="!item.error && !item.loaded" class="text-primary">ĐANG TẢI</span>
                                                <span v-if="item.error" class="text-danger">LỖI</span>
                                            </p>
                                        </div>
                                        <button class="border-0" style="height: 42px; background-color: transparent; padding: 0; color: #0700e7;" @click="dowloadFile(item)">Tải xuống</button>
                                    </div>
                                    <b-progress v-if="!item.loaded && !item.error" class="border" height="1rem">
                                        <b-progress-bar :value="item.progress" :variant="resolveUploadProgressState(item)" :animated="!item.loaded" striped :label="`${item.progress}%`"></b-progress-bar>
                                    </b-progress>

                                    <button v-if="item.error" class="border-0" style="height: 42px; background-color: transparent; padding: 0; color: #0700e7;" @click="reUpload(item)">Tải lại</button>
                                    
                                    <audio controls v-if="item.loaded && !item.error && item?.question?.answers?.value">
                                        <source :src="item?.question?.answers?.value">
                                    </audio>
                                </div>
                            </div>

                            <b-button style="min-width: 200px;" class="custom" variant="success" v-if="uploadDone" @click="$bvModal.hide('uploadProcess')">XONG</b-button>
                            
                            <b-button style="min-width: 200px;" class="custom" variant="warning" v-if="uploadError" @click="$bvModal.hide('uploadProcess')">VẪN NỘP BÀI</b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-modal>
    
    <div class="loading-screen" :class="{show : appLoading}">
        <svg class="spinner">
            <circle cx="20" cy="20" r="18"></circle>
        </svg>
    </div>
    <router-view />
</div>
</template>

<script>
/* eslint-disable */

// import EventBus from './libs/EventBus'


import reporter from './plugins/reporter'


export default {
    data() {
        return {
            vueAppClasses: [],
            preloadError: false,
            uploadDone: false,
            uploadError: false,
            uploadProcess: {},
            testEnd: false,
        };
    },
    computed: {
        appLoading() {
            return this.$TestApp.getAppLoading()
        },
        fbTracking () {
            return this.$store.getters['fbTracking']
        },
    },
    watch: {

        preloadError (value) {
            if (value) {
                this.$bvModal.hide('confirm-info')
                this.$bvModal.show('preloadError')
            }
        },

        fbTracking (value) {
            if (value) {
                const trackingList = value.split(/\n/)
                trackingList.forEach(fbTracking => {
                    if (fbTracking) {
                        this.$analytics.fbq.init(fbTracking)
                    }
                })
            }
        }
    },
    methods: {
        getTrackingId () {
            return  localStorage.getItem('_speakup_track') ? 'TraceId: ' + localStorage.getItem('_speakup_track') : ''
        },
        reUpload (item) {
            this.$TestApp.reUploadFile(item)
        },
        dowloadFile(fileItem) {

            const { file, question } = fileItem
            const questionContent = JSON.parse(question?.content || '{}')
            const fileName = `${questionContent?.title ? questionContent?.title : 'file'}-${new Date().getTime()}.mp3`

            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";


            var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            var isChrome =
            navigator.userAgent.toLowerCase().indexOf("CriOS") > -1 ||
            navigator.vendor.toLowerCase().indexOf("google") > -1;
            var iOSVersion = [];
            if (iOS) {
            iOSVersion = navigator.userAgent
                .match(/OS [\d_]+/i)[0]
                .substr(3)
                .split("_")
                .map((n) => parseInt(n));
            }
            
            try {
                const linkElement = document.createElement("a");

                const url = window.URL.createObjectURL(file);

                linkElement.setAttribute('href', url);
                linkElement.setAttribute('target', '_blank');
                
                const attachmentName = fileName + '.mp3';

                if ((iOS && (iOSVersion[0] > 12 || isChrome)) || !iOS) {
                    linkElement.setAttribute("download", attachmentName);
                }
                var clickEvent = new MouseEvent("click", {
                    view: window,
                    bubbles: true,
                    cancelable: false
                });
                linkElement.dispatchEvent(clickEvent);
                
            } catch (error) {
                
            }
        },
        jsonParse(string) {
            try {
                return JSON.parse(string)
            } catch (error) {
                //
            }
            return {}
        },
        resolveUploadProgressState (state) {
            if (state?.error) {
                return 'error'
            }

            if (!state?.loaded && !state?.error) {
                return 'primary'
            }

            return 'success'

        },
    },
    async mounted() {
        var message = "NoRightClicking";
        function defeatIE() {
            if (document.all) {
                (message);
                return false;
            }
        }
        function defeatNS(e) {
            if (document.layers || (document.getElementById && !document.all)) {
                if (e.which == 2 || e.which == 3) {
                    (message);
                    return false;
                }
            }
        }
        if (document.layers) {
            document.captureEvents(Event.MOUSEDOWN);
            document.onmousedown = defeatNS;
        } else {
            document.onmouseup = defeatNS;
            document.oncontextmenu = defeatIE;
        }
        document.oncontextmenu = new Function("return false")


        // if (window.location.href.indexOf('localhost:') == -1) {
        //     ! function t() {
        //         try {
        //             ! function t(n) {
        //                 1 === ("" + n / n).length && 0 !== n || function() {}.constructor("debugger")(), t(++n)
        //             }(0)
        //         } catch (n) {
        //             setTimeout(t, 100) // thời gian độ trễ
        //         }
        //     }();
        // }


        document.addEventListener("visibilitychange", () => {
            console.log(document.visibilityState);
        })

        this.$analytics.fbq.event('PageView');
    },
    async created() {
        const Reporter = reporter.init();

        window.EventBus.$on('preload_error_report', (error) => {
            Reporter.event('PRELOAD_ERROR', JSON.stringify(error));
        })

        window.EventBus.$on('preload_done_report', (error) => {
            Reporter.event('PRELOAD_DONE', JSON.stringify(error));
        })

        window.EventBus.$on('preload_error', (error) => {
            this.preloadError = error
        })

        window.EventBus.$on('updateProgress', (progress) => {
            this.uploadProcess = progress
        })

        window.EventBus.$on('uploadProcess', () => {
            this.uploadDone = true
        })
        window.EventBus.$on('uploadError', () => {
            this.uploadError = true
        })
        window.EventBus.$on('testEnd', (uploadCount) => {
            if (uploadCount)
            this.$bvModal.show('uploadProcess')
        })
    },
    destroyed() {},
};
</script>

<style>
/* 
.content_question table {
    max-width: 100%;
}

.content_question table, .content_question tr, .content_question td {
    border: 1px solid #000;
} */

.toast:not(.show){
    display: block !important;
}

.question-block {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
}

.audio.no-replay button {
    padding: 0;
    border: none;
    background-color: transparent;
    cursor: pointer;
}

.audio.no-replay .pause-icon {
    display: none;
}

.audio.no-replay.play .pause-icon {
    display: block;
}

.audio.no-replay.play .play-icon {
    display: none;
}

.audio.no-replay svg {
    width: 50px;
    height: 50px;
    color: #22acfb;
}


img {
    max-width: 100%;
}

.loading-screen {
    display: none;
    width: 100%;
    height: 100vh;
    background-color: #0000004d;
    position: fixed;
    z-index: 99999999;
}

.loading-screen.show {
    display: block !important;
}

svg.spinner {
    width: 40px;
    height: 40px;
    x: 0px;
    y: 0px;
    viewbox: 0 0 40 40;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

svg.spinner circle {
    fill: transparent;
    stroke: #d0d0d0;
    stroke-width: 4;
    stroke-linecap: round;
    stroke-dasharray: 125.6;
    -webkit-transform-origin: 20px 20px 0;
    -moz-transform-origin: 20px 20px 0;
    -ms-transform-origin: 20px 20px 0;
    -o-transform-origin: 20px 20px 0;
    transform-origin: 20px 20px 0;
    -webkit-animation: spinner 2s linear infinite;
    -moz-animation: spinner 2s linear infinite;
    -ms-animation: spinner 2s linear infinite;
    -o-animation: spinner 2s linear infinite;
    animation: spinner 2s linear infinite;
}

@-webkit-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        stroke-dashoffset: 26.4;
    }

    50% {
        -webkit-transform: rotate(720deg);
        stroke-dashoffset: 125.6;
    }

    100% {
        -webkit-transform: rotate(1080deg);
        stroke-dashoffset: 26.4;
    }
}

@-moz-keyframes spinner {
    0% {
        -moz-transform: rotate(0deg);
        stroke-dashoffset: 26.4;
    }

    50% {
        -moz-transform: rotate(720deg);
        stroke-dashoffset: 125.6;
    }

    100% {
        -moz-transform: rotate(1080deg);
        stroke-dashoffset: 26.4;
    }
}

@-ms-keyframes spinner {
    0% {
        -ms-transform: rotate(0deg);
        stroke-dashoffset: 26.4;
    }

    50% {
        -ms-transform: rotate(720deg);
        stroke-dashoffset: 125.6;
    }

    100% {
        -ms-transform: rotate(1080deg);
        stroke-dashoffset: 26.4;
    }
}

@-o-keyframes spinner {
    0% {
        -o-transform: rotate(0deg);
        stroke-dashoffset: 26.4;
    }

    50% {
        -o-transform: rotate(720deg);
        stroke-dashoffset: 125.6;
    }

    100% {
        -o-transform: rotate(1080deg);
        stroke-dashoffset: 26.4;
    }
}

@keyframes spinner {
    0% {
        transform: rotate(0deg);
        stroke-dashoffset: 26.4;
    }

    50% {
        transform: rotate(720deg);
        stroke-dashoffset: 125.6;
    }

    100% {
        transform: rotate(1080deg);
        stroke-dashoffset: 26.4;
    }
}
</style>
